import SongDetails from '../Components/SongDetails';

const Show = () => {
  return (
    <div>
      <h2>Show</h2>
      <SongDetails />
    </div>
  );
};

export default Show;
